var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndividualData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 56.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.54 23.58l-2.19-1.73A21.38 21.38 0 0029.16 1.72v-.51A1.21 1.21 0 0028 0h-7.9a1.21 1.21 0 00-1.21 1.21v.51A21.38 21.38 0 002.65 21.85L.46 23.58a1.18 1.18 0 00-.46.94v3.4a1.21 1.21 0 001.21 1.2h6v10.21a16.76 16.76 0 1033.52 0V29.12h6a1.21 1.21 0 001.27-1.2v-3.4a1.18 1.18 0 00-.46-.94zm-9.19 15.75a14.35 14.35 0 01-28.7 0V29.12h28.7zm7.24-12.62H2.41v-1.6l2.18-1.72a1.21 1.21 0 00.46-.95A19 19 0 0118.84 4.21v2.66a1.21 1.21 0 002.42 0V2.41h5.49v4.46a1.21 1.21 0 102.41 0V4.21A19 19 0 0143 22.44a1.21 1.21 0 00.46.95l2.18 1.72z",
    fill: "#fff",
    "data-name": "Layer 1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualData);
export default __webpack_public_path__ + "static/media/individual-data.32e5c436.svg";
export { ForwardRef as ReactComponent };